/**
 * The help popover: the canvas gestures each editor has but never shows.
 *
 * The shortcut half of that popover is not here — a shortcut supplies its own label
 * from wherever it is bound, so it is documented next to the binding it describes.
 *
 * Which editor lists which of these is decided in utils/_shared/editorHelp.ts. Every
 * entry below is a real handler; check the code before adding one.
 */

export default {
	help: {
		title: "Keyboard and canvas",
		shortcuts: "Shortcuts",
		canvas: "Canvas",
		panels: "Panels",
		gestures: {
			// ── Information model ──
			dataobjectDrag: {
				gesture: "Drag from the list",
				effect: "Adds that dataobject to the view where you drop it.",
			},
			modelCanvasDoubleClick: {
				gesture: "Double-click the canvas",
				effect: "Adds an existing dataobject, or creates a new one under the name you type.",
			},
			modelNodeDoubleClick: {
				gesture: "Double-click a node",
				effect: "Opens its relations in the properties panel.",
			},
			modelAltDrag: {
				gesture: "{key} + drag one node onto another",
				effect: "Defines a relation from the node you dragged from to the one you drop on.",
			},
			modelTypeAltClick: {
				gesture: "{key} + click an attribute's datatype",
				effect: "Opens that datatype on the Datatypes page.",
			},
			modelLinkClick: {
				gesture: "Click a relation line",
				effect: "Deletes that relation, after asking.",
			},
			modelNodeContextMenu: {
				gesture: "Right-click a node",
				effect: "Opens a menu: remove it from the view, or delete the dataobject entirely.",
			},

			// ── Process ──
			pdoDrag: {
				gesture: "Drag from the overview",
				effect: "Adds a root dataobject. Dragging the same one again adds a second copy.",
			},
			processCanvasDoubleClick: {
				gesture: "Double-click the canvas",
				effect: "Adds a root dataobject at that spot.",
			},
			processNodeDoubleClick: {
				gesture: "Double-click a node",
				effect: "Opens its relations in the properties panel.",
			},
			processAltDrag: {
				gesture: "{key} + drag one node onto another",
				effect: "Hangs the node you drop on beneath the one you dragged from, out of wherever it hung before.",
			},
			processNodeContextMenu: {
				gesture: "Right-click a node",
				effect: "Opens a menu. Removing from there takes everything attached beneath the node with it.",
			},

			// ── Activity ──
			actionDrag: {
				gesture: "Drag from the palette",
				effect: "Adds that action where you drop it.",
			},
			actionConnect: {
				gesture: "Drag between two dots",
				effect: "Connects the actions. Dots that cannot take the connection dim.",
			},
			edgeClick: {
				gesture: "Click a connection",
				effect: "Offers to remove it, right where you clicked.",
			},
			actionCanvasDoubleClick: {
				gesture: "Double-click the canvas",
				effect: "Opens a search for an action to copy in from another activity.",
			},
			actionContextMenu: {
				gesture: "Right-click an action",
				effect: "Opens a menu: edit it, duplicate it, recolour it, or delete it.",
			},

			// ── Shared ──
			stickyTab: {
				gesture: "Click node after node",
				effect: "Whichever tab you have open stays open, so you can compare the same facet.",
			},
			panelResize: {
				gesture: "Drag a panel's inner edge",
				effect: "Resizes it. The width is remembered for next time.",
			},
		},
	},
};
